/* eslint-disable camelcase */
export default class Wire {
  constructor(source) {
    Object.assign(this, source || {
      id: null,
      title: '',
      sent_contact_count: 0,
      unsent_contact_count: 0,
    });
  }

  get total_contact_count() {
    return this.sent_contact_count + this.unsent_contact_count;
  }
}
/* eslint-enable camelcase */
